import React, { useState, useEffect, useContext } from 'react';

import 'animate.css';
import "../assets/css/website.css";

import Logo from "../assets/img/logo_cabecera.png";
import LogoFooter from "../assets/img/Home/logo_alma_footer.png";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookSharpIcon from '@mui/icons-material/FacebookSharp';
import TwitterIcon from '@mui/icons-material/Twitter';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import iosDown from "../assets/img/Home/descargar_appstore.png";
import playDown from "../assets/img/Home/descargar_playstore.png";

import useCategories from '../hooks/categories/useCategories';
import sanitizeUrl from '../utils/sanitizeUrl';
import Cart from '../components/Cart/Cart';
import { CartContext } from '../context/CartContext';

const MainLayout = ({ children }) => {
    const [menuActive, setMenuActive] = useState(false);
    const {
        openCart,
        isOpenCart
    } = useContext(CartContext);

    const { 
        categoriesMenu, 
        fetchCategoriesMenu 
    } = useCategories();

    useEffect(() => {
        fetchCategoriesMenu();
    }, []);

    const [width, setWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            <header id='header' className='pt-md-4 py-2 bg-white'>
                <div className='container d-flex justify-content-between align-items-center'>
                    <div className='logo pe-5'>
                        <a href="/">
                            <img src={Logo} alt="Logo" />
                        </a>
                    </div>
                    <div className='d-flex flex-column w-100 justify-content-center'>
                        <div className='d-flex header-top gap-4 align-items-center w-100 justify-content-end'>
                            <div className='d-lg-flex d-none' style={{
                                maxWidth: "240px",
                                width: "100%"
                            }}>
                                <button className='btn btn-action-primary' type="button">
                                    <LocationOnIcon className='me-2' />
                                    Ingresa tu ubicación
                                </button>
                            </div>
                            <div className='search-bar d-lg-flex d-none'>
                                <SearchIcon />
                                <input type="text" className='' placeholder='Busca lo que quieres' />
                            </div>
                            <div className='d-flex justify-content-end'>
                                <button onClick={openCart} className='btn btn-cart text-white' type="button">
                                    <ShoppingCartIcon />
                                </button>

                                <button onClick={() => setMenuActive(true)} className='d-lg-none d-block btn btn-nav-toggle'>
                                    <MenuIcon style={{
                                        color: "#9B9B9B"
                                    }} />
                                </button>
                            </div>
                        </div>

                        <div className='w-100'>
                            <nav className={`
                                navbar pb-0 main-navbar navbar-expand-lg 
                                ${menuActive && width <= 991 ? 
                                    "active animate__animated animate__slideInRight"
                                    : ""
                                }
                            `}>
                                <div className="d-lg-none d-flex align-items-center p-3">
                                    <button onClick={() => setMenuActive(false)} className="btn p-0">
                                        <ArrowBackIosIcon />
                                    </button>
                                    <div className='search-bar'>
                                        <SearchIcon />
                                        <input type="text" className='' placeholder='Busca lo que quieres' />
                                    </div>
                                </div>
                                <ul className='navbar-nav'>
                                    {categoriesMenu.length > 0 ? (
                                        categoriesMenu.map((category, key) => (
                                            <li key={key} className='nav-item'>
                                                <a className='nav-link' 
                                                    href={`/tienda/${sanitizeUrl(category.name)}?uid=${category.uid}&categoryName=${category.name}`}
                                                >
                                                    {category.name}
                                                </a>
                                            </li>
                                        ))
                                    ) : (
                                        <></>
                                    )}
                                    <li className='nav-item'>
                                        <a className='nav-link text-secondary' href="/">
                                            Para empresas
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div className='container d-lg-none d-flex mt-md-4 mt-2 justify-content-between align-items-center'>
                    <div className='search-bar'>
                        <SearchIcon />
                        <input type="text" className='' placeholder='Buscar' />
                    </div>
                </div>
            </header>

            <main>{children}</main>

            <Cart openCart={openCart} isOpenCart={isOpenCart} />

            <footer className="footer">
                <div className="container py-5 border-bottom d-flex justify-content-center align-items-center flex-md-row flex-column">
                    <div className="px-md-4 px-2 text-md-left text-center">
                        <h3>Descarga la App</h3>
                        <p>Ahora puedes tener un universo de productos únicos en tú celular. Disponible para iOS y Android</p>
                    </div>
                    <div className="px-md-4 px-2 d-flex flex-column">
                        <a className="btn btn-down-app" href="/">
                            <img width="130" src={iosDown} alt="IosLogo" />
                        </a>
                        <a className="btn btn-down-app" href="/">
                            <img width="130" src={playDown} alt="PlayLogo" />
                        </a>
                    </div>
                </div>
                <div className="container flex-column flex-md-row pt-5 pb-4 d-flex justify-content-center align-items-center">
                    <div className="p-4 border-md-right text-center">
                        <div className="logo-footer">
                            <a href="/">
                                <img width="133" src={LogoFooter} alt="logo" />
                            </a>
                        </div>
                        <nav className="nav-rs-footer">
                            <ul>
                                <li>
                                    <a href="/">
                                        <InstagramIcon />
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        <FacebookSharpIcon />
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        <TwitterIcon />
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="p-4">
                        <nav className="nav-footer">
                            <ul>
                                <li>
                                    <a href="/">
                                        Para empresas 
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        Mi cuenta 
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        Términos y Condiciones 
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        Preguntas frecuentes 
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        Contáctanos 
                                    </a>
                                </li>
                                <li>
                                    <a href="/">
                                        Rastrea tu pedido
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="copyright container d-flex align-items-center justify-content-center">
                    <p className="w-100 text-center mb-0 py-4">
                        Copyright © 2020 Todos los derechos reservados
                    </p>
                </div>
            </footer>
        </>
    )
};

export default MainLayout;
